import React from 'react'

const MajorMicrophone = props => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 17.48a4.54 4.54 0 004.54-4.54V6.55a4.54 4.54 0 10-9.08 0v6.39A4.55 4.55 0 0012 17.48zM9 6.55a3.04 3.04 0 016.08 0v6.39a3.04 3.04 0 11-6.08 0V6.55zm10 6.27V12.25a.75.75 0 00-1.5 0v.55a5.2 5.2 0 01-5.2 5.2h-.6a5.2 5.2 0 01-5.2-5.18.75.75 0 00-1.5 0 6.7 6.7 0 006.25 6.68v1h-3.5a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-3.5v-1A6.7 6.7 0 0019 12.82z"
      fill={props.fill || '#fff'}
    />
  </svg>
  )

export default MajorMicrophone
